import { render, staticRenderFns } from "./partnerlist.vue?vue&type=template&id=0ab98969&scoped=true"
import script from "./partnerlist.vue?vue&type=script&lang=js"
export * from "./partnerlist.vue?vue&type=script&lang=js"
import style0 from "./partnerlist.vue?vue&type=style&index=0&id=0ab98969&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.40_babel-core@7.0.0-bridge.0_@babel+core@7.29._1a562a7ff44e47125e24b47fdbb3ae4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab98969",
  null
  
)

export default component.exports